import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { cx } from '../../../utils/cx';

export const BaseSkeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <Skeleton
      className={cx('block h-full w-full rounded-md', className)}
      baseColor="#f0f3f9"
      highlightColor="#f9fafd"
      {...props}
    />
  );
};

const SkeletonContent = () => {
  return (
    <div className="flex flex-col gap-2">
      <div className="h-4 w-1/3">
        <BaseSkeleton />
      </div>
      <div className="h-3 w-full">
        <BaseSkeleton />
      </div>
      <div className="h-3 w-full">
        <BaseSkeleton />
      </div>
      <div className="h-3 w-2/3">
        <BaseSkeleton />
      </div>
    </div>
  );
};

export interface SkeletonLoaderProps {
  className?: string;
  count?: number;
}

export const SkeletonLoader = ({
  className,
  count = 1
}: SkeletonLoaderProps) => {
  return (
    <div className={cx('flex flex-col gap-4', className)}>
      <div className="h-8 w-1/4">
        <BaseSkeleton />
      </div>
      {[...Array(count).keys()].map((i) => (
        <SkeletonContent key={`skeleton-${i}`} />
      ))}
    </div>
  );
};
